<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/craftsman/manage' }"
          >手艺人管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          craftsmanForm.workUserId ? "编辑手艺人" : "新建手艺人"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        :model="craftsmanForm"
        :rules="rules"
        ref="craftsmanForm"
        label-width="68px"
        class="demo-craftsmanForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="头像" prop="headLogo">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'headLogo');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'headLogo');
                }
              "
              :before-upload="beforeImgUpload"
              :on-exceed="limitTip"
              :file-list="headLogo"
              :limit="1"
            >
              <div
                style="width:148px;height:148px;position:absolute;"
                @click="show_uploadDialog(1, 'headLogo')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item label="工号" prop="workNum">
          <el-input
            placeholder="请输入工号"
            @input.native="inputChange($event)"
            v-model="craftsmanForm.workNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName">
          <el-input
            v-model="craftsmanForm.nickName"
            placeholder="请输入姓名"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNum">
          <el-input
            :disabled="craftsmanForm.workUserId ? true : false"
            placeholder="请输入手机号"
            type="number"
            v-model="craftsmanForm.phoneNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="craftsmanForm.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="网店显示">
          <el-radio-group v-model="craftsmanForm.isShowInOnlineStore">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预约量">
          <el-input
            placeholder="请填写预约量"
            @input.native="inputChange($event)"
            v-model="craftsmanForm.appointmentNum"
          ></el-input>
        </el-form-item>
        <el-form-item label="介绍" maxlength="100">
          <el-input
            type="textarea"
            placeholder="请填写介绍"
            v-model="craftsmanForm.introduce"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="images">
          <div>
            <el-upload
              :disabled="uploadDisabled"
              action="/ImageServer/YmUpload_image"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="
                (e) => {
                  handleRemove(e, 'images');
                }
              "
              :http-request="
                (e) => {
                  handleSuccess(e, 'images');
                }
              "
              :before-upload="beforeImgUpload"
              :file-list="images"
              :before-remove="beforeRemove"
            >
              <div
                style="width:148px;height:148px;position:absolute;"
                @click="show_uploadDialog(999, 'images')"
              ></div>
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('craftsmanForm')"
            :loading="isSubmit"
            >{{ craftsmanForm.workUserId ? "提交编辑" : "立即创建" }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <uploadImgComponent
      :isshow_uploadDialog="isshow_uploadDialog"
      @onClose="close_uploadDialog"
      @getChoose_ImgUrl="getChoose_ImgUrl"
      ref="childRef"
      :ImgLimits="ImgLimits"
      :uploadName="uploadName"
    ></uploadImgComponent>
  </div>
</template>

<script>
import { uploadImg, artisansInfo, saveOrUpdateArtisans } from "@/api";
import uploadImgComponent from "@/components/uploadImg";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      images: [],
      headLogo: [],
      craftsmanForm: {
        workUserId: "",
        workNum: "",
        nickName: "",
        phoneNum: "",
        headLogo: "",
        sex: 1,
        isShowInOnlineStore: 1,
        appointmentNum: 0,
        introduce: "",
        images: "",
        indexNo: 0,
      },
      rules: {
        headLogo: [
          {
            required: true,
            message: "请至少上传头像",
            trigger: "blur",
          },
        ],
        images: [
          {
            required: true,
            message: "请至少上传一张图片",
            trigger: "blur",
          },
        ],
        workNum: [
          {
            required: true,
            message: "请填写工号",
            trigger: "blur",
          },
        ],
        nickName: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        phoneNum: [
          {
            pattern: /^1[123456789]\d{9}$/,
            required: true,
            message: "请填写正确的手机号",
            trigger: "blur",
          },
          ,
        ],
      },
      isSubmit: false,
      isshow_uploadDialog: false,
      uploadDisabled: false,
      ImgLimits: 0,
      uploadName: "",
    };
  },
  components: {
    uploadImgComponent,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
  },
  mounted() {
    console.log(this.$router, this.$route);
    let workUserId = this.$route.query.workUserId;
    if (workUserId) {
      this.craftsmanForm.workUserId = workUserId;
      this.artisansInfo();
    }
  },
  methods: {
    show_uploadDialog(val, name) {
      this.ImgLimits = val;
      this.uploadName = name;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = [];
      this.isshow_uploadDialog = true;
    },
    getChoose_ImgUrl(arr, name) {
      console.log(arr, name);
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (name == "images") {
            if (this.craftsmanForm.images.length) {
              this.craftsmanForm.images += `,${item.image}`;
            } else {
              this.craftsmanForm.images = item.image;
            }
            this.images.push({ name: "", url: item.image });
            return;
          }
          this.craftsmanForm[name] = item.image;
          this[name] = [{ url: this.craftsmanForm[name] }];
        });
      }
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    artisansInfo() {
      artisansInfo({
        workUserId: this.craftsmanForm.workUserId,
      }).then((res) => {
        let craftsmanForm = {
          workUserId: res.data.workUserId,
          workNum: res.data.workNum,
          nickName: res.data.nickName,
          phoneNum: res.data.phoneNum,
          sex: res.data.sex,
          isShowInOnlineStore: res.data.isShowInOnlineStore,
          appointmentNum: res.data.appointmentNum,
          introduce: res.data.introduce,
          indexNo: res.data.indexNo || 0,
          headLogo: res.data.headLogo || "",
          images: res.data.images || "",
        };
        let headLogo = craftsmanForm.headLogo
          ? craftsmanForm.headLogo.split(",")
          : [];
        if (headLogo.length && headLogo[0].length) {
          headLogo.forEach((val) => {
            this.headLogo.push({
              name: val,
              url: val,
            });
          });
        }
        let images = craftsmanForm.images
          ? craftsmanForm.images.split(",")
          : [];
        if (images.length && images[0].length) {
          images.forEach((val) => {
            this.images.push({
              name: val,
              url: val,
            });
          });
        }
        this.craftsmanForm = craftsmanForm;
      });
    },
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "images") {
        let images = this.craftsmanForm.images.split(",");
        images.splice(images.indexOf(file.url), 1);
        this.images.splice(
          this.images.findIndex((val) => val.url == file.url),
          1
        );
        this.craftsmanForm.images = "";
        this.craftsmanForm.images = images.join(",");
      } else {
        this.craftsmanForm[name] = "";
        this[name] = [];
      }
    },
    limitTip(files, fileList) {
      console.log(file, "file", fileList, "fileList");
      this.$notify({
        title: "警告",
        message: "只能上传一张图片，请删除图片后再上传",
        type: "warning",
        duration: 6000,
      });
    },
    beforeRemove(file, fileList) {},
    beforeImgUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isLt3M;
    },
    handleSuccess(item, name) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        console.log(res);
        if (res.code == 1) {
          if (name == "images") {
            if (this.craftsmanForm[name].length) {
              this.craftsmanForm[name] += `,${res.data.url}`;
            } else {
              this.craftsmanForm[name] = res.data.url;
            }
            return;
          }
          this.craftsmanForm[name] = res.data.url;
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    inputChange(e) {
      if (!e.target.value) return;
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = Number(e.target.value);
    },
    submitForm(formName) {
      console.log(this.craftsmanForm, "提交编辑");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.craftsmanForm));
          params.fullName = params.nickName;
          this.isSubmit = true;
          saveOrUpdateArtisans(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: this.craftsmanForm.workUserId
                  ? "编辑成功"
                  : "创建成功",
                type: "success",
                duration: 3000,
              });
              this.$router.push({
                path: "/craftsman/manage",
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .custom-form {
    width: 1080px;
    background: #f8f8f8;
    font-size: 14px;
    color: #606266;
    padding: 12px 0 20px 20px;
    box-sizing: border-box;
    .form-header,
    .form-content > .item {
      display: flex;
      & > div {
        margin-right: 20px;
      }
      .fixed-width {
        width: 124px;
        .tips {
          font-size: 12px;
          color: red;
          white-space: nowrap;
        }
        .el-input {
          width: 140px;
        }
      }
      .indefinite-width {
        .el-input {
          width: 100px;
          margin: 0 16px 0 10px;
        }
        .el-tag {
          margin-right: 10px;
        }
        .el-button--text {
          margin-left: 10px;
        }
      }
    }
    & > .el-button {
      margin-top: 18px;
    }
  }
  .el-form-item__content {
    .el-input,
    .el-textarea {
      width: 380px;
    }
  }
  .el-radio {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.goodsUrl {
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  opacity: 0;
}
</style>
